// extracted by mini-css-extract-plugin
export default {"info":"TestInfo_info__AgFCY","timer":"TestInfo_timer__jp+vz"};